import "./style/icon.scss";
import "./style/yolopay.scss";

export * from "./interface";

export { default as IconPaypalText } from "./IconPaypalText";
export { default as IconPaypalWhite } from "./IconPaypalWhite";
export { default as IconPaypal } from "./IconPaypal";
export { default as IconStripe } from "./IconStripe";
export { default as IconPaypalBlock } from "./IconPaypalBlock";
export { default as IconStripeText } from "./IconStripeText";
export { default as IconSecure } from "./IconSecure";
export { default as IconMoneyBackGuarantee } from "./IconMoneyBackGuarantee";
export { default as IconDataPrivacy } from "./IconDataPrivacy";
export { default as IconServiceSupport } from "./IconServiceSupport";
export { default as IconSad } from "./IconSad";
export { default as IconShoppingBag } from "./IconShoppingBag";
export { default as IconMenu } from "./IconMenu";
export { default as IconClose } from "./IconClose";
export { default as IconPayssionPay } from "./IconPayssionPay";
export { default as IconAlipay } from "./IconAlipay";
export { default as IconWechatPay } from "./IconWechatPay";
export { default as IconBankCard } from "./IconBankCard";
export { default as IconSpeaker } from "./IconSpeaker";
export { default as IconLike } from "./IconLike";
export { default as IconInfo } from "./IconInfo";
export { default as IconFire } from "./IconFire";
export { default as IconVideo } from "./IconVideo";
export { default as IconTipLighting } from "./IconTipLighting";
export { default as IconTipProduct } from "./IconTipProduct";
export { default as IconTipVideo } from "./IconTipVideo";
export { default as IconCheck } from "./IconCheck";
export { default as IconCloseBlue } from "./IconCloseBlue";
export { default as IconRefresh } from "./IconRefresh";
export { default as IconChoose } from "./IconChoose";
export { default as IconMaskClose } from "./IconMaskClose";
export { default as IconBottomArrow } from "./IconBottomArrow";
export { default as IconSuccessBG } from "./IconSuccessBG";
export { default as IconGo } from "./IconGo";
export { default as IconSmallGo } from "./IconSmallGo";
export { default as IconGift } from "./IconGift";
export { default as IconJoin } from "./IconJoin";
export { default as IconFlash } from "./IconFlash";
export { default as IconTaskAlert } from "./IconTaskAlert";
export { default as IconTaskWallet } from "./IconTaskWallet";
export { default as IconTaskJoin } from "./IconTaskJoin";
export { default as IconTaskPrice } from "./IconTaskPrice";
export { default as IconTaskUnitsSold } from "./IconTaskUnitsSold";
export { default as IconTaskCreators } from "./IconTaskCreators";
export { default as IconTaskRating } from "./IconTaskRating";
export { default as IconAdClose } from "./IconAdClose";
export { default as IconAdOpenArrow } from "./IconAdOpenArrow";
export { default as IconCopy } from "./IconCopy";
export { default as IconPencil } from "./IconPencil";
export { default as IconArrowDown } from "./IconArrowDown";
export { default as IconToSelect } from "./IconToSelect";
export { default as IconOnSelected } from "./IconOnSelected";
export { default as IconCloseRound } from "./IconCloseRound";
export { default as IconAiQuestions } from "./IconAiQuestions";
export { default as IconAiPaste } from "./IconAiPaste";
export { default as IconAiExtracting } from "./IconAiExtracting";
export { default as IconAiView } from "./IconAiView";
export { default as IconAiRewrite } from "./IconAiRewrite";
export { default as IconAiPlay } from "./IconAiPlay";
export { default as IconPlay } from "./IconPlay";
export { default as IconPause } from "./IconPause";
export { default as IconFullScreen } from "./IconFullScreen";
export { default as IconExitFullScreen } from "./IconExitFullScreen";
export { default as IconArrow } from "./IconArrow";
export { default as IconMessageClear } from "./IconMessageClear";
export { default as IconBfYFLogo } from "./IconBfYFLogo";
export { default as IconRankBg } from "./IconRankBg";
export { default as IconBfMoneySmall } from "./IconBfMoneySmall";
export { default as IconBfMoneyBig } from "./IconBfMoneyBig";
export { default as IconRankFirstBg } from "./IconRankFirstBg";
export { default as IconPopupClose } from "./IconPopupClose";
export { default as IconFlashTwo } from "./IconFlashTwo";
export { default as IconSpark } from "./IconSpark";
export { default as IconAdArrow } from "./IconAdArrow";
export { default as IconQuestion } from "./IconQuestion";
export { default as IconAdCheck } from "./IconAdCheck";
export { default as IconRadioCheck } from "./IconRadioCheck";
export { default as IconResultSuccess } from "./IconResultSuccess";
export { default as IconHamburger } from "./IconHamburger";
export { default as IconWarningArrow } from "./IconWarningArrow";
export { default as IconDoubleArrow } from "./IconDoubleArrow";
export { default as IconDoller } from "./IconDoller";
